/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SurveyHistoryAnswer,
    SurveyHistoryAnswerFromJSON,
    SurveyHistoryAnswerFromJSONTyped,
    SurveyHistoryAnswerToJSON,
    VideoHistoryAnswer,
    VideoHistoryAnswerFromJSON,
    VideoHistoryAnswerFromJSONTyped,
    VideoHistoryAnswerToJSON,
} from './';

/**
 * 
 * @export
 * @interface StatisticsAnswer
 */
export interface StatisticsAnswer {
    /**
     * 
     * @type {number}
     * @memberof StatisticsAnswer
     */
    numWeeks?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsAnswer
     */
    goalsCompleted?: number;
    /**
     * 
     * @type {Array<SurveyHistoryAnswer>}
     * @memberof StatisticsAnswer
     */
    surveyHistory?: Array<SurveyHistoryAnswer>;
    /**
     * 
     * @type {Array<VideoHistoryAnswer>}
     * @memberof StatisticsAnswer
     */
    videoHistory?: Array<VideoHistoryAnswer>;
    /**
     * 
     * @type {number}
     * @memberof StatisticsAnswer
     */
    videoStreak?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsAnswer
     */
    careerHighVideoStreak?: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsAnswer
     */
    totalVideosCompleted?: number;
}

export function StatisticsAnswerFromJSON(json: any): StatisticsAnswer {
    return StatisticsAnswerFromJSONTyped(json, false);
}

export function StatisticsAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numWeeks': !exists(json, 'num-weeks') ? undefined : json['num-weeks'],
        'goalsCompleted': !exists(json, 'goals-completed') ? undefined : json['goals-completed'],
        'surveyHistory': !exists(json, 'survey-history') ? undefined : ((json['survey-history'] as Array<any>).map(SurveyHistoryAnswerFromJSON)),
        'videoHistory': !exists(json, 'video-history') ? undefined : ((json['video-history'] as Array<any>).map(VideoHistoryAnswerFromJSON)),
        'videoStreak': !exists(json, 'video-streak') ? undefined : json['video-streak'],
        'careerHighVideoStreak': !exists(json, 'career-high-video-streak') ? undefined : json['career-high-video-streak'],
        'totalVideosCompleted': !exists(json, 'total-videos-completed') ? undefined : json['total-videos-completed'],
    };
}

export function StatisticsAnswerToJSON(value?: StatisticsAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'num-weeks': value.numWeeks,
        'goals-completed': value.goalsCompleted,
        'survey-history': value.surveyHistory === undefined ? undefined : ((value.surveyHistory as Array<any>).map(SurveyHistoryAnswerToJSON)),
        'video-history': value.videoHistory === undefined ? undefined : ((value.videoHistory as Array<any>).map(VideoHistoryAnswerToJSON)),
        'video-streak': value.videoStreak,
        'career-high-video-streak': value.careerHighVideoStreak,
        'total-videos-completed': value.totalVideosCompleted,
    };
}


